/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */

/**
 *
 * DownloadReport
 *
 */

import React, { memo, useState, useContext, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import moment from 'moment';
import {
  Button,
  Popup,
  EllipsisPopup,
  Conditional,
  ConfirmModal,
  Text,
  Space,
  Loader,
} from '@cashfree-intl/coherent';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import {
  formatBytes,
  titleCase,
  isEPOSApproved,
  useQuery,
  isSubscriptionEnabled,
} from 'utils/common';
import {
  TX_STATUS_CLASSNAME,
  DEFAULT_CURRENT_PAGE,
  DEFAULT_LIMIT_OPTIONS,
  DATE_AND_TIME_FORMAT,
  DOWNLOAD_REPORT,
} from 'utils/constants';

import CustomIcons from 'components/CustomIcons';
import GenerateReportModal from 'components/GenerateReportModal';

import ShareReportModal from 'components/ShareReportModal';
import PaginatedTable from 'components/PaginatedTable';
import { formatColumns } from 'components/PaginatedTable/helpers';

import makeSelectDownloadReport from './selectors';
import reducer from './reducer';
import saga from './saga';
import {
  // COLUMNS_LIST,
  HEADINGS,
  // MAPPING_FOR_GENERATE_REPORT,
  // MAPPING_FOR_REPORT_NAME,
  PAYMENT_LINK_TXN_STATUS,
  DONE,
  REQUESTED,
  ERROR,
  PROCESSING,
  MENU_ITEMS,
  DELETE,
  PAYMENT_LINK_TRANSACTIONS,
  SOFTPOS,
  DROPDOWN_FILTERS_PAYLOAD_MAPPING,
  VENDOR_RECON,
  VENDOR_ORDER_RECON,
  SHARE,
} from './constants';
import {
  enableLoaderAction,
  updateFiltersAction,
  updateTableDataAction,
  searchGeneratedReportsAction,
  resetFiltersAction,
  getReportByIdAction,
  downloadReportAction,
  deleteReportAction,
  generateReportAction,
  resetPageAction,
  resetModalAction,
  resetDataAction,
  getVendorReconReportAction,
  searchVendorReconSettlementSpecificReportAction,
  handleNewReportStatusAction,
  getVendorOrderReconReport as getVendorOrderReconReportAction,
  getMerchantRouteAction,
  merchantRetargetConfigAction,
  shareReportAction,
} from './actions';

import { MerchantContext } from '../../contexts/MerchantContext';
import { resetTwoFactorAuthentication as resetTwoFactorAuthenticationValue } from '../Toast/actions';
import { twoFactorAuthenticationSelector } from '../Toast/selectors';
import DashboardFilters from '../DashboardFilters';
import EVENTS from '../../constants/analytics';
import Analytics from '../../utils/analytics';
import { getReportOptions } from './helpers';
import { StyledResultText } from './styled';

export function DownloadReport({
  isModuleFederated = false,
  downloadReport,
  searchGeneratedReports,
  enableLoader,
  updateTableData,
  updateFilters,
  resetFilters,
  getReportById,
  downloadReportFn,
  deleteReport,
  generateReport,
  twoFactorAuthentication,
  resetTwoFactorAuthentication,
  resetPage,
  resetModal,
  resetData,
  getVendorReconReport,
  handleNewReportStatus,
  searchVendorReconSettlementSpecificReport,
  getVendorOrderReconReport,
  getMerchantRoute,
  merchantRetargetConfig,
  shareReport,
}) {
  useInjectReducer({ key: 'downloadReport', reducer });
  useInjectSaga({ key: 'downloadReport', saga });

  const {
    easySplitEnabled,
    isFlowwiseActive,
    isMerchantImportEnabled,
  } = useContext(MerchantContext);

  const { state } = useLocation();

  const query = useQuery();
  const env = query.get('env');

  const [openModal, resetModalView] = useState('');
  const [modalData, resetModalData] = useState({});
  const [merchantRoutesData, setMerchantRoutesData] = useState([]);
  const [isRetargetEnabled, setRetargetEnabled] = useState(false);
  const intervalArr = useRef([]);
  const [shareReportLinkData, resetShareReportLinkData] = useState({
    link: '',
  });
  const [shareReportLoader, resetShareReportLoader] = useState(false);

  const {
    isLoading,
    showDownloadModal,
    downloadModalData,
    filters = {},
    filtersForDisplay,
    hasPrev,
    hasNext,
    currentPageRowData,
    data,
  } = downloadReport;

  const FORMATTED_COLUMN_ID = formatColumns(HEADINGS);

  const noRecordsObj = {
    icon: <CustomIcons componentName="BOX" />,
    text: 'No results found',
  };

  const getTableData = (f = filters) => {
    // make api call
    enableLoader();
    const { appliedFilters, dateFilters, applyFilter, ...rest } = f;
    const formattedFilterObj = { ...rest, ...appliedFilters };

    if (!formattedFilterObj.type) formattedFilterObj.type = 'all';
    if (formattedFilterObj.type)
      formattedFilterObj.reportType = formattedFilterObj.type;

    searchGeneratedReports({
      options: formattedFilterObj,
      isModuleFederated,
    });
  };

  const onPageChange = type => {
    const options = { ...filters };
    switch (type) {
      case 'NEXT':
        options.pageNo += 1;
        break;
      case 'PREV':
        options.pageNo -= 1;
        break;
      default:
        break;
    }
    updateFilters(options);
  };

  const onLimitChange = (e, limitChangeData) => {
    const options = {
      ...filters,
      pageNo: DEFAULT_CURRENT_PAGE,
      pageSize: parseInt(limitChangeData.value, 10),
    };
    updateFilters(options);
    Analytics.track(EVENTS.REPORTS.PAGE_SIZE, {
      pageSize: limitChangeData.value,
    });
  };

  // const handleOptionClick = option => () => {
  //   resetSelectedOption(option);
  //   Analytics.track(EVENTS.REPORTS.REPORT_TYPE, { reportType: option.value });
  // };

  const handleGenerateReportClick = () => {
    resetModalData({});
    resetModalView('GENERATE_REPORT');
    Analytics.track(EVENTS.REPORTS.GENERATE_REPORT);
  };

  const handleDownloadConfirm = () => {
    const { type, reportId } = downloadModalData;
    downloadReportFn({
      reportId,
      type,
    });
    resetModal();
    Analytics.track(EVENTS.REPORTS.DOWNLOAD_REPORT);
  };

  const deleteReportFn = () => {
    enableLoader();
    deleteReport({ reportId: modalData.reportId });
    resetModalView('');
    resetModalData({});
    Analytics.track(EVENTS.REPORTS.DELETE_REPORT);
  };

  const handleRowCTAClick = (rowData, action) => {
    const { status, _id: reportId, name, type } = rowData;
    if (action === DELETE) {
      resetModalData({ reportId, name });
      resetModalView('DELETE_REPORT');
    } else if (action === SHARE) {
      resetShareReportLinkData({ link: '' });
      resetModalData({ reportId, name });
      resetModalView('SHARE_REPORT');
      Analytics.trackEventWithNewNomenclature({
        eventName: EVENTS.REPORTS.SHARE_REPORT,
      });
    } else if (status === REQUESTED) {
      enableLoader();
      getReportById({ reportId });
    } else if (status === DONE) {
      enableLoader();
      downloadReportFn({ reportId, type });
      Analytics.track(EVENTS.REPORTS.DOWNLOAD_REPORT);
    }
  };

  const getReportType = rowData => {
    let str = rowData.type;
    if (rowData.name.includes('Payment Link'))
      str = 'Payment Link Transactions';
    else str = DROPDOWN_FILTERS_PAYLOAD_MAPPING[rowData.type] || rowData.type;
    return str;
  };

  const getMenuItems = status => {
    const condition = obj =>
      (status === DONE && obj.value === DONE) ||
      (status === DONE && obj.value === SHARE) ||
      (status === REQUESTED && obj.value === REQUESTED) ||
      ([DONE, REQUESTED, ERROR].includes(status) && obj.value === DELETE);

    const items = MENU_ITEMS.filter(obj => condition(obj)).map(obj => ({
      ...obj,
      image: () => (
        <CustomIcons componentName={obj.key} fill="var(--PRIMARY)" />
      ),
    }));
    return items;
  };

  const onItemClick = rowData => (e, itemSelected) => {
    e.stopPropagation();
    handleRowCTAClick(rowData, itemSelected === DELETE ? DELETE : itemSelected);
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Table_Row_EllipsisPopup',
      eventProperties: {
        row_id: rowData._id,
      },
    });
  };

  const renderCTA = rowData => {
    if ([DONE, REQUESTED, ERROR].includes(rowData.status)) {
      const items = getMenuItems(rowData.status);
      if (items.length === 1) {
        return () => (
          <Popup
            content="Delete Report"
            position="bottom right"
            offset="10px"
            trigger={
              <span
                className="table-cta-item"
                onClick={() => handleRowCTAClick(rowData, DELETE)}
                data-event-name="Table_Row_Delete"
                data-ignore-inner-text="true"
                data-event-properties={JSON.stringify({
                  row_id: rowData._id,
                })}
              >
                <CustomIcons componentName="DELETE_SPLIT" />
              </span>
            }
          />
        );
      }
      return () => (
        <EllipsisPopup
          menuItems={items}
          onClick={onItemClick(rowData)}
          data-event-name="Table_Row_EllipsisPopup"
          data-ignore-inner-text="true"
          data-event-properties={JSON.stringify({
            row_id: rowData._id,
          })}
        />
      );
    }
    return null;
  };

  const renderReportStatus = rowData => (
    <span
      className={`w-600 ${TX_STATUS_CLASSNAME[rowData.status] || ''} ${
        rowData.status === PROCESSING ? 'shimmer' : ''
      }`}
    >
      {titleCase(rowData.status)}
    </span>
  );

  useEffect(() => {
    if (data.length > 0 && state && state.reportData) {
      const result = state.reportData;
      pollGetReportById(result._id);
      handleNewReportStatus(result);
      delete state.reportData;
    }
    if (!isLoading) {
      const totalCount = data.length;
      const pageData = JSON.parse(JSON.stringify(data));

      const formattedData = [];

      pageData.forEach(rowData => {
        if (DROPDOWN_FILTERS_PAYLOAD_MAPPING[rowData.type]) {
          formattedData.push({
            ...rowData,
            // eslint-disable-next-line no-underscore-dangle
            id: rowData._id,
            type: getReportType(rowData),
            name: rowData.name,
            size: rowData.size ? formatBytes(+rowData.size) : '',
            createdAt: () =>
              moment(rowData.createdAt).format(DATE_AND_TIME_FORMAT),
            reportStatus: ![DONE, REQUESTED].includes(rowData.status)
              ? () => renderReportStatus(rowData)
              : null,
            reportsCTA: renderCTA(rowData),
            generatedBy: () => {
              if (rowData.generatedBy === 'scheduler') {
                return (
                  <StyledResultText variant="b12" type="scheduled">
                    Scheduled
                  </StyledResultText>
                );
              }
              return (
                <StyledResultText variant="b12" type="adhoc">
                  Ad-Hoc
                </StyledResultText>
              );
            },
          });
        }
      });

      const hasPrevEnabled = filters.pageNo !== 1;
      const hasNextEnabled = totalCount >= filters.pageSize;

      updateTableData({
        totalCount,
        hasPrevEnabled,
        hasNextEnabled,
        currentPageRowData: formattedData,
      });
    }
  }, [isLoading, data]);

  const closeModal = () => resetModalView('');

  const pollGetReportById = reportId => {
    let count = 0;
    const interval = setInterval(() => {
      count += 1;
      if (count > 5) clearInterval(interval);
      else getReportById({ interval, reportId, count });
    }, 5000);
    intervalArr.current.push(interval);
  };

  useEffect(
    () => () => {
      if (intervalArr && intervalArr.current && intervalArr.current.length > 0)
        intervalArr.current.forEach(interval => clearInterval(interval));
      // for resetting the redux state
      resetData();
    },
    [intervalArr],
  );

  const handleReportModalSubmit = (payload, actions) => {
    const { dateRangeSelected, reportType, ...rest } = payload;
    if (dateRangeSelected.range && dateRangeSelected.range.length > 1) {
      enableLoader();

      let additionalParams = {};
      if (reportType.key === PAYMENT_LINK_TRANSACTIONS)
        additionalParams = { paymentLinks: 1, status: PAYMENT_LINK_TXN_STATUS };
      else if (reportType.key === SOFTPOS)
        additionalParams = { softposflag: 1 };

      if (
        reportType.key === VENDOR_RECON &&
        (rest.vendorId || rest.settlementId)
      ) {
        if (rest.vendorId) {
          getVendorReconReport({
            cb: reportId => {
              pollGetReportById(reportId);
              actions.setSubmitting(false);
            },
            options: {
              startDate: moment(dateRangeSelected.range[0]).format(
                'YYYY-MM-DD 00:00:00',
              ),
              endDate: moment(dateRangeSelected.range[1]).format(
                'YYYY-MM-DD 23:59:59',
              ),
              reportType: reportType.value,
              ...rest,
            },
            closeModal,
            actions,
          });
        } else if (rest.settlementId) {
          searchVendorReconSettlementSpecificReport({
            cb: reportId => {
              pollGetReportById(reportId);
              actions.setSubmitting(false);
            },
            options: {
              reportType: reportType.value,
              ...rest,
            },
            closeModal,
            actions,
          });
        }
      } else if (reportType.key === VENDOR_ORDER_RECON && rest.orderIds) {
        getVendorOrderReconReport({
          cb: reportId => {
            pollGetReportById(reportId);
            actions.setSubmitting(false);
          },
          options: {
            startDate: moment(dateRangeSelected.range[0]).format(
              'YYYY-MM-DD 00:00:00',
            ),
            endDate: moment(dateRangeSelected.range[1]).format(
              'YYYY-MM-DD 23:59:59',
            ),
            reportType: reportType.value,
            ...rest,
          },
          closeModal,
          actions,
        });
      } else {
        closeModal();
        generateReport({
          cb: reportId => {
            pollGetReportById(reportId);
            actions.setSubmitting(false);
          },
          options: {
            startDate: moment(dateRangeSelected.range[0]).format(
              'YYYY-MM-DD 00:00:00',
            ),
            endDate: moment(dateRangeSelected.range[1]).format(
              'YYYY-MM-DD 23:59:59',
            ),
            reportType: reportType.value,
            ...rest,
            ...additionalParams,
          },
          actions,
        });
      }
      Analytics.track(EVENTS.REPORTS.GENERATED_REPORT, {
        startDate: moment(dateRangeSelected.range[0]).format(
          DATE_AND_TIME_FORMAT,
        ),
        endDate: moment(dateRangeSelected.range[1]).format(
          DATE_AND_TIME_FORMAT,
        ),
        reportType: reportType.value,
        ...rest,
      });
    }
  };

  useEffect(() => {
    getTableData(filters);
  }, [filters, env]);

  useEffect(() => {
    resetData();
    merchantRetargetConfig({
      configKey: 'RETARGET',
      cb: res => {
        if (res && res.length && res[0].status === 'ACTIVE') {
          setRetargetEnabled(true);
        } else {
          setRetargetEnabled(false);
        }
      },
    });
  }, [env]);

  useEffect(() => {
    if (twoFactorAuthentication) {
      getTableData();
      resetTwoFactorAuthentication(false);
    }
  }, [twoFactorAuthentication]);

  useEffect(() => {
    getMerchantRoute({
      cb: mData => {
        setMerchantRoutesData(mData);
      },
    });
  }, []);

  const reportOptions = getReportOptions({
    easySplitEnabled,
    isModuleFederated,
    isRetargetEnabled,
    isFlowwiseActive,
    isSubscriptionEnabled: isSubscriptionEnabled(),
    isEPOSApproved: isEPOSApproved(),
    isMerchantImportEnabled,
  });

  const getShareableReportLink = values => {
    resetShareReportLoader(true);
    let reportName = modalData.name;
    if (values.auth_channel !== undefined && values.auth_channel !== null) {
      if (values.auth_channel === 'PHONE') {
        reportName = reportName.substring(0, 25);
      }
    }
    shareReport({
      reqOptions: {
        ...values,
        report_id: modalData.reportId,
        report_name: reportName,
      },
      successCb: () => {
        resetShareReportLoader(false);
        resetModalView('');
      },
      errorCb: () => {
        resetShareReportLoader(false);
        resetModalView('');
      },
    });
  };

  return (
    <div>
      <Conditional if={isLoading}>
        <Loader active />
      </Conditional>
      <Conditional if={openModal === 'GENERATE_REPORT'}>
        <GenerateReportModal
          open
          closeModal={closeModal}
          reportOptions={reportOptions}
          handleReportModalSubmit={handleReportModalSubmit}
          modalData={modalData}
          merchantRoutesData={merchantRoutesData}
        />
      </Conditional>
      <Conditional if={openModal === 'DELETE_REPORT'}>
        <ConfirmModal
          danger
          title="Delete Report"
          onClose={closeModal}
          onConfirm={deleteReportFn}
          confirmText="Delete"
          confirmBtnEvent="Danger_Button_Delete_Report_Confirm"
          closeBtnEvent="Link_Button_Delete_Report_Cancel"
          closeCrossEvent="Delete_Report_Icon_Close"
        >
          Are you sure you want to delete {modalData.name}?
        </ConfirmModal>
      </Conditional>
      <Conditional if={showDownloadModal}>
        <ConfirmModal
          onClose={resetModal}
          onConfirm={handleDownloadConfirm}
          title="Download Report"
          confirmText="Download"
          danger={false}
          confirmBtnEvent="Primary_Button_Download_Report_Confirm"
          closeBtnEvent="Link_Button_Download_Report_Cancel"
          closeCrossEvent="Download_Report_Icon_Close"
        >
          Report has already been generated for the given period. Do you want to
          download{' '}
          {downloadModalData.type === 'tx_report'
            ? `${downloadModalData.reportName}.zip`
            : downloadModalData.reportName}{' '}
          file?
        </ConfirmModal>
      </Conditional>
      <Conditional if={openModal === 'SHARE_REPORT'}>
        <ShareReportModal
          onClose={() => resetModalView('')}
          onConfirm={getShareableReportLink}
          link={shareReportLinkData.link}
          isLoading={shareReportLoader}
        />
      </Conditional>
      {/* <div className="horizontal-divider" /> */}
      <Text variant="b14" color="bodyLight" className="mb-3 mt-4">
        Generated reports are shown below.
      </Text>
      <div className="generate-reports-container">
        {/* <div className="section-heading fnt-16">Generated Reports</div> */}
        {/* <div className="filters-container"> */}
        <Space justifyContent="space-between" alignItems="baseline">
          <DashboardFilters
            menuSelected="REPORTS"
            filters={filters}
            filtersForDisplay={filtersForDisplay}
            activeNavigation={DOWNLOAD_REPORT}
            getTableDataFn={getTableData}
            resetFilterFn={resetFilters}
            updateFilterFn={updateFilters}
            resetPageFn={resetPage}
          />
          <Button
            primary
            type="button"
            onClick={handleGenerateReportClick}
            data-event-name="Primary_Button_GenerateNewReport"
          >
            Generate New Report
          </Button>
        </Space>
        <PaginatedTable
          data={currentPageRowData}
          tableHeading={FORMATTED_COLUMN_ID}
          emptyTableComponent={noRecordsObj}
          limit={filters.pageSize}
          limitOptions={DEFAULT_LIMIT_OPTIONS}
          hasPrev={hasPrev}
          hasNext={hasNext}
          currentPage={filters.pageNo}
          currentPageCount={currentPageRowData.length}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          fetching={isLoading}
        />
      </div>
      {/* </div> */}
    </div>
  );
}

DownloadReport.propTypes = {
  isModuleFederated: PropTypes.bool,
  downloadReport: PropTypes.object.isRequired,
  searchGeneratedReports: PropTypes.func.isRequired,
  enableLoader: PropTypes.func.isRequired,
  updateTableData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  getReportById: PropTypes.func.isRequired,
  downloadReportFn: PropTypes.func.isRequired,
  deleteReport: PropTypes.func.isRequired,
  generateReport: PropTypes.func.isRequired,
  twoFactorAuthentication: PropTypes.bool.isRequired,
  resetTwoFactorAuthentication: PropTypes.func.isRequired,
  resetPage: PropTypes.func,
  resetModal: PropTypes.func,
  resetData: PropTypes.func.isRequired,
  getVendorReconReport: PropTypes.func.isRequired,
  handleNewReportStatus: PropTypes.func.isRequired,
  searchVendorReconSettlementSpecificReport: PropTypes.func.isRequired,
  getVendorOrderReconReport: PropTypes.func.isRequired,
  getMerchantRoute: PropTypes.func,
  merchantRetargetConfig: PropTypes.func,
  shareReport: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  downloadReport: makeSelectDownloadReport(),
  twoFactorAuthentication: twoFactorAuthenticationSelector(),
});

function mapDispatchToProps(dispatch) {
  return {
    searchGeneratedReports: data =>
      dispatch(searchGeneratedReportsAction(data)),
    enableLoader: () => dispatch(enableLoaderAction()),
    updateTableData: data => dispatch(updateTableDataAction(data)),
    updateFilters: data => dispatch(updateFiltersAction(data)),
    resetFilters: data => dispatch(resetFiltersAction(data)),
    getReportById: data => dispatch(getReportByIdAction(data)),
    downloadReportFn: data => dispatch(downloadReportAction(data)),
    deleteReport: data => dispatch(deleteReportAction(data)),
    generateReport: data => dispatch(generateReportAction(data)),
    resetTwoFactorAuthentication: data =>
      dispatch(resetTwoFactorAuthenticationValue(data)),
    resetPage: () => dispatch(resetPageAction()),
    resetModal: () => dispatch(resetModalAction()),
    resetData: () => dispatch(resetDataAction()),
    getVendorReconReport: data => dispatch(getVendorReconReportAction(data)),
    searchVendorReconSettlementSpecificReport: data =>
      dispatch(searchVendorReconSettlementSpecificReportAction(data)),
    handleNewReportStatus: data => dispatch(handleNewReportStatusAction(data)),
    getVendorOrderReconReport: data =>
      dispatch(getVendorOrderReconReportAction(data)),
    getMerchantRoute: data => dispatch(getMerchantRouteAction(data)),
    merchantRetargetConfig: data =>
      dispatch(merchantRetargetConfigAction(data)),
    shareReport: data => dispatch(shareReportAction(data)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(DownloadReport);
